export const comments_3294069 = {"data":{"data":[],"links":{}}}